import React from 'react';
import './services.css'

const Services = () => {
    return (
        <div className='mx-10 my-20' id="services">
            <div>
                <span className='title '>SERVICES</span>
                <h3 className='subtitle'>What I provide</h3>
            </div>

            <div className='flex flex-col items-center lg:flex-row lg:items-stretch gap-4 my-8'>

                <div className="max-w-sm p-10 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">
                    <i class="fa-sharp fa-solid fa-compass-drafting service-icon"></i>

                    <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white service-title">UI/UX design</h5>

                    <p className="service-info mb-3 font-normal text-gray-500 dark:text-gray-400">
                        A website is completely done according to the given design such as figma file. You can see my project also.
                    </p>

                </div>
                <div className="max-w-sm p-10 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">

                    <i class="fa-solid fa-code service-icon"></i>

                    <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white service-title">Web development</h5>

                    <p className="service-info mb-3 font-normal text-gray-500 dark:text-gray-400">
                        I have 1.5 years experience on web development sector. In the mean time, I have completed a lot of projects.
                    </p>

                </div>
                <div className="max-w-sm p-10 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">

                    <i class="fa-solid fa-mobile service-icon"></i>
                    <h5 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white service-title">Responsive design</h5>

                    <p className="service-info mb-3 font-normal text-gray-500 dark:text-gray-400">
                        The designed website will be fully responsive. The website will be fit in the mobile and tablet. My designed website's are fully responsive. You can see my project.
                    </p>

                </div>

            </div>
        </div>
    );
};

export default Services;